import {createAsyncThunk} from '@reduxjs/toolkit';

import {
    IGetUserFunctionsArgs,
    IGetUserFunctionsByDocIdArgs,
    getUserFunctions,
    getUserFunctionsByDocId,
} from './user-slice-api';
import {USER_SLICE} from './user-slice-constants';
import {EUserRoleFunction} from './user-slice-role-functions';

export const loadUserFunctions = createAsyncThunk<
    EUserRoleFunction[], IGetUserFunctionsArgs
>(
    `${USER_SLICE}/loadUserFunctions`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await getUserFunctions(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const loadUserFunctionsByDocId = createAsyncThunk<
    EUserRoleFunction[], IGetUserFunctionsByDocIdArgs
>(
    `${USER_SLICE}/loadUserFunctionsByDocId`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await getUserFunctionsByDocId(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
